export class AutorizationUser{
    credencial:any;
    response:any;
    token:string;
}